<template>
    <article class="article">
        <AppBreadcrumbs
            :base-url="runtimeConfig.public.BASE_URL"
            :parents="[
                {
                    name: config.brand_name,
                    full_slug: '',
                },
                ...parentPages,
            ]"
            :current="{
                name: article.name,
                full_slug: article.full_slug,
            }"
        />

        <div class="article__main">
            <div class="article__content">
                <ArticleHead :title="title" />

                <!-- Like the page content type, this one has no dedicated LCP
                     image, so the first content blok gets the priority slot
                     (hero/main-header opt into eager + fetchpriority + preload
                     from it; every later blok stays lazy). -->
                <StoryblokComponent
                    v-for="(contentBlok, index) in article.content.content"
                    :key="contentBlok._uid"
                    :story="article"
                    :blok="contentBlok"
                    :priority="index === 0"
                />
            </div>
        </div>
    </article>
</template>

<script setup>
import ArticleHead from '~/components/article-head/article-head.vue'
import seoTitle from '~/helpers/seoTitle'

const { data } = defineProps({
    data: {
        type: Object,
        required: true,
    },
})

const config = useState('config')

const route = useRoute()
const { slug } = route.params

const runtimeConfig = useRuntimeConfig()

const { article } = data

// Doubles as the visible h1 — this content type has no separate heading field,
// so an empty meta_title used to render an empty <h1> as well.
const title = seoTitle(article)

const parentPages = computed(() => {
    if (Array.isArray(slug) && slug.length > 1) {
        return slug.slice(0, -1).map((item, index) => {
            return {
                name: (item.charAt(0).toUpperCase() + item.slice(1)).replace('-', ' '),
                full_slug: `${slug.slice(0, index + 1).join('/')}`,
            }
        })
    }

    return []
})

// Only ever opt *out*. `index, follow` is already the @nuxtjs/robots default, and setting
// it explicitly would override the site-wide noindex that preview/staging hosts get from
// server/plugins/site-indexable.js. `noindex, follow` and not `useRobotsRule(false)`:
// `false` resolves to the module's `robotsDisabledValue` (`noindex, nofollow`), whose
// nofollow also cuts the crawl path to any indexable children.
if (article.content.index === false)
    useRobotsRule('noindex, follow')

useHead({
    title,
    meta: [
        {
            hid: 'description',
            name: 'description',
            content: article.content.meta_description,
        },
    ],
})
</script>
